import { z } from 'zod'

/**
 * Copy of {@link FlagSearchDto} but with coerce for parse
 */
export const FlagSearchCoerceSchema = z.object({
	isSearchWithDynamicAndStaticData: z.coerce.boolean(),
	isSearchOnlyStaticData: z.coerce.boolean().optional(),
	isSearchWithRoomReviewsAndFAQ: z.coerce.boolean().optional(),
	isSearchWithBlog: z.coerce.boolean().optional(),
	isSavingRawIntegrationResponse: z.coerce.boolean().optional()
})
